import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import GlobalVariable from "../../../../services/globalVar";
import { Tag } from "antd";
import * as XLSX from "xlsx"; // <-- Excel export library

const InvoiceDetails = (props) => {
  const parentData = props;

  const exportToExcel = () => {
    if (!parentData.invoiceDetails || parentData.invoiceDetails.length === 0) {
      alert("No data to export");
      return;
    }

    const dataToExport = parentData.invoiceDetails.map((row) => ({
      "Customer Name": `${row.firstName} ${row.lastName}`,
      "Invoice Date": format(
        new Date(row.invoiceDate),
        GlobalVariable.userDet.tenantConfig.dateFormat
      ),
      "Due Date": format(
        new Date(row.dueDate),
        GlobalVariable.userDet.tenantConfig.dateFormat
      ),
      "Invoice Number": row.invoiceNumber,
      "Shipping Address": `${row.saAddress1} ${row.saAddress2}, ${row.saCity}, ${row.saState}, ${row.saZipCode}`,
      Status: row.status,
      Total: `${parentData.currency}${row.totalAmount.toFixed(2)}`,
      Balance: `${parentData.currency}${row.balancePayment.toFixed(2)}`
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Invoice Details");
    XLSX.writeFile(workbook, "InvoiceDetails.xlsx");
  };

  const dueDateFormBodyTemplate = (rowData) => {
    return (
      <div className="date-wrapper">
        <span className="date-value">
          {format(
            new Date(rowData.dueDate),
            GlobalVariable.userDet.tenantConfig.dateFormat
          )}
        </span>
      </div>
    );
  };

  const invoiceDateFormBodyTemplate = (rowData) => {
    return (
      <div className="date-wrapper">
        <span className="date-value">
          {format(
            new Date(rowData.invoiceDate),
            GlobalVariable.userDet.tenantConfig.dateFormat
          )}
        </span>
      </div>
    );
  };

  const nameFormBodyTemplate = (rowData) => {
    const fullName = rowData.firstName + " " + rowData.lastName;
    return (
      <div className="customer-name-wrapper">
        <div className="customer-avatar">
          {fullName?.charAt(0)?.toUpperCase() || 'C'}
        </div>
        <div className="customer-details">
          <span className="customer-name">{fullName}</span>
        </div>
      </div>
    );
  };

  const invoiceNumberTemplate = (rowData) => {
    return (
      <div className="invoice-number-wrapper">
        <span className="">
          {rowData.invoiceNumber}
        </span>
      </div>
    );
  };

  const hippingAddressTemplate = (rowData) => {
    const address = rowData.saAddress1 + " " + rowData.saAddress2 + " ," + rowData.saCity + " ," + rowData.saState + ", " + rowData.saZipCode;
    return (
      <div className="" title={address}>
        <i className="pi pi-map-marker address-icon"></i>
        <span className=""> {address || "-"}</span>
      </div>
    );
  };

  const statusBodyTemplate = (rowData) => {
    let status = rowData.status.toUpperCase();
    let statusClass;

    switch (status) {
      case "OPEN":
        statusClass = "orange";
        break;
      case "PARTIALLY PAID":
        statusClass = "processing";
        break;
      case "PAID":
        statusClass = "green";
        break;
      case "DRAFT":
        statusClass = "purple";
        break;
      case "OVERDUE":
        statusClass = "error";
        break;
      default:
        statusClass = "cyan";
    }

    return (
      <div className="status-wrapper">
        <Tag bordered={false} color={statusClass}>
          {status}
        </Tag>
      </div>
    );
  };

  const totalAmountTemplate = (rowData) => (
    <div className="amount-wrapper">
      <span className="currency-symbol">{parentData.currency}</span>
      <span className="amount-value">{rowData.totalAmount.toFixed(2)}</span>
    </div>
  );

  const balanceTemplate = (rowData) => (
    <div className="amount-wrapper balance-amount">
      <span className="currency-symbol">{parentData.currency}</span>
      <span className="amount-value">{rowData.balancePayment.toFixed(2)}</span>
    </div>
  );

  return (
    <div className="bg-white shadow-sm chart-of-account h-100 cc-greyCard-custm1 enhanced-invoice-container">
      <div className="row coa-header kk-header-sec px-4 py-2">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <div className="header-title"> 
            <div className="section-title">
              <i className="pi pi-file " style={{fontSize:"22px"}} ></i>
              Invoice Report
            </div>
          </div>
          <button className="btn btn-primary" onClick={exportToExcel}>
            <i className="pi pi-download"></i> Download Excel
          </button>
        </div>
      </div>

      <div className="account-table enhanced-table-wrapper">
        <DataTable
          stripedRows
          showGridlines
          tableStyle={{ minWidth: "100%" }}
          className="enhanced-datatable"
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 25, 50]}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          paginatorLeft={
            <div className="paginator-info">
              <span>Total Invoices: {parentData.invoiceDetails?.length || 0}</span>
            </div>
          }
          value={parentData.invoiceDetails}
          emptyMessage={
            <div className="empty-state">
              <i className="pi pi-file empty-icon"></i>
              <h5>No data available</h5>
              <p>There are no invoice details to display</p>
            </div>
          }
          responsiveLayout="scroll"
        >
           <Column
            field="customerName"
            header={
              <div className="column-header">
                <span>Customer Name</span>
              </div>
            }
            body={nameFormBodyTemplate}
            headerStyle={{ background: '#f8f9fa', fontWeight: '600' }}
            style={{ width: "18%", minWidth: "200px" }}
            sortable
          />
          <Column
            field="invoiceDate"
            header={
              <div className="column-header">
                <span>Invoice Date</span>
              </div>
            }
            body={invoiceDateFormBodyTemplate}
            headerStyle={{ background: '#f8f9fa', fontWeight: '600' }}
            style={{ width: "9%" }}
            sortable
          />

          <Column
            field="dueDate"
            header={
              <div className="column-header">
                <span>Due Date</span>
              </div>
            }
            body={dueDateFormBodyTemplate}
            headerStyle={{ background: '#f8f9fa', fontWeight: '600' }}
            style={{ width: "8%" }}
            sortable
          />

          <Column
            field="invoiceNumber"
            header={
              <div className="column-header">
                <span>Invoice Number</span>
              </div>
            }
            body={invoiceNumberTemplate}
            headerStyle={{ background: '#f8f9fa', fontWeight: '600' }}
            style={{ width: "11%" }}
            sortable
          />

          <Column
            field="shippingAddress"
            header={
              <div className="column-header">
                <span>Shipping Address</span>
              </div>
            }
            body={hippingAddressTemplate}
            headerStyle={{ background: '#f8f9fa', fontWeight: '600' }}
            style={{ width: "22%" }}
          />

          <Column
            field="status"
            header={
              <div className="column-header">
                <span>Status</span>
              </div>
            }
            body={statusBodyTemplate}
            headerStyle={{ background: '#f8f9fa', fontWeight: '600', textAlign: 'center' }}
            style={{ width: "4%", textAlign: 'center' }}
            sortable
          />

          <Column
            field="totalAmount"
            header={
              <div className="column-header">
                <span>Total</span>
              </div>
            }
            className="text-end amount-align"
            body={totalAmountTemplate}
            headerStyle={{ background: '#f8f9fa', fontWeight: '600', textAlign: 'right' }}
            style={{ width: "8%" }}
            sortable
          />

          <Column
            field="balancePayment"
            header={
              <div className="column-header">
                <span>Balance</span>
              </div>
            }
            className="text-end amount-align"
            body={balanceTemplate}
            headerStyle={{ background: '#f8f9fa', fontWeight: '600', textAlign: 'right' }}
            style={{ width: "8%" }}
            sortable
          />
        </DataTable>
      </div>

      <style jsx>{`
        .enhanced-invoice-container {
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
          border: 1px solid #e5e7eb;
        }

        .enhanced-header {
                                  background: linear-gradient(115deg, rgba(87, 199, 133, 1) 0%,  rgba(42, 123, 155, 1) 100%);

          color: white;
          padding: 1.5rem 0;
          margin: 0;
        }

        .header-content {
          padding: 0 1.5rem;
        }

        .section-title {
          margin: 0;
          font-size: 1.5rem;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .section-subtitle {
          margin: 0.25rem 0 0 0;
          opacity: 0.9;
          font-size: 0.95rem;
          font-weight: 400;
        }

        .header-icon {
          font-size: 1.25rem;
          opacity: 0.9;
        }

        .enhanced-table-wrapper {
          padding: 0;
        }

        .enhanced-datatable {
          border: none !important;
        }

        .enhanced-datatable .p-datatable-tbody > tr {
          transition: all 0.2s ease;
        }

        .enhanced-datatable .p-datatable-tbody > tr:hover {
          background: #f8f9fa !important;
          transform: translateY(-1px);
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .enhanced-datatable .p-datatable-tbody > tr > td {
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #f1f3f4;
          vertical-align: middle;
        }

        .column-header {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #374151;
        }

        .column-header .header-icon {
          font-size: 0.9rem;
          color: #6b7280;
        }

        .customer-name-wrapper {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .customer-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
                                  background: linear-gradient(115deg, rgba(87, 199, 133, 1) 0%,  rgba(42, 123, 155, 1) 100%);

          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 600;
          font-size: 0.9rem;
          flex-shrink: 0;
        }

        .customer-details {
          display: flex;
          flex-direction: column;
        }

        .customer-name {
          font-weight: 500;
          color: #1f2937;
          font-size: 0.95rem;
        }

        .date-wrapper {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .date-icon {
          color: #6b7280;
          font-size: 0.9rem;
        }

        .date-value {
          color: #1f2937;
          font-weight: 500;
          font-size: 0.9rem;
        }

        .invoice-number-wrapper {
          display: flex;
          justify-content: center;
        }

        .invoice-badge {
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          color: white;
          padding: 0.375rem 0.75rem;
          border-radius: 20px;
          font-weight: 600;
          font-size: 0.875rem;
          text-align: center;
          box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
        }

        .address-wrapper {
          display: flex;
          align-items: flex-start;
          gap: 0.5rem;
          max-width: 300px;
        }

        .address-icon {
          color: #6b7280;
          font-size: 0.9rem;
          margin-top: 0.1rem;
          flex-shrink: 0;
        }

        .address-text {
          color: #1f2937;
          font-size: 0.9rem;
          line-height: 1.4;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .status-wrapper {
          display: flex;
          justify-content: center;
        }

        .amount-wrapper {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 0.25rem;
          font-family: 'Segoe UI', 'SF Pro Display', system-ui, sans-serif;
          font-weight: 500;
        }

        .currency-symbol {
          color: #6b7280;
          font-size: 0.9rem;
          font-weight: 500;
        }

        .amount-value {
          color: #1f2937;
          font-size: 1rem;
          font-weight: 600;
          font-variant-numeric: tabular-nums;
        }

        .balance-amount .amount-value {
          color: #059669;
        }

        .empty-state {
          text-align: center;
          padding: 3rem 2rem;
          color: #6b7280;
        }

        .empty-icon {
          font-size: 3rem;
          color: #d1d5db;
          margin-bottom: 1rem;
        }

        .empty-state h5 {
          color: #374151;
          margin-bottom: 0.5rem;
          font-weight: 600;
        }

        .empty-state p {
          margin: 0;
          font-size: 0.9rem;
        }

        .enhanced-datatable .p-paginator {
          background: #f9fafb;
          border: none;
          border-top: 1px solid #e5e7eb;
          padding: 1rem 1.5rem;
        }

        .enhanced-datatable .p-paginator .p-paginator-pages .p-paginator-page {
          border-radius: 6px;
          margin: 0 2px;
        }

        .enhanced-datatable .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
          background: #667eea;
          border-color: #667eea;
        }

        .paginator-info {
          display: flex;
          align-items: center;
          color: #6b7280;
          font-weight: 500;
          font-size: 0.9rem;
        }

        .enhanced-datatable .p-paginator .p-dropdown {
          margin-right: 0.5rem;
        }

        .enhanced-datatable .p-paginator .p-paginator-current {
          background: transparent;
          color: #374151;
          font-weight: 500;
        }

        @media (max-width: 768px) {
          .enhanced-header {
            padding: 1rem 0;
          }

          .header-content {
            padding: 0 1rem;
          }

          .section-title {
            font-size: 1.25rem;
          }

          .enhanced-datatable .p-datatable-tbody > tr > td {
            padding: 0.75rem 1rem;
          }

          .customer-avatar {
            width: 35px;
            height: 35px;
            font-size: 0.8rem;
          }

          .customer-name-wrapper {
            gap: 0.5rem;
          }

          .amount-wrapper {
            flex-direction: column;
            gap: 0;
            align-items: flex-end;
          }

          .address-wrapper {
            max-width: 200px;
          }
        }

        @media (max-width: 576px) {
          .column-header {
            font-size: 0.85rem;
          }

          .customer-name {
            font-size: 0.85rem;
          }

          .amount-value {
            font-size: 0.9rem;
          }

          .invoice-badge {
            font-size: 0.8rem;
            padding: 0.25rem 0.5rem;
          }

          .date-value {
            font-size: 0.8rem;
          }

          .address-text {
            font-size: 0.8rem;
          }
        }
      `}</style>
    </div>
  );
};

export default InvoiceDetails;